import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const list = createReducer([], {
  [ActionTypes.FETCH_FEATURED_ARTICLES_SUCCESS]: (state, { payload }) => payload
});

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_FEATURED_ARTICLES_SUCCESS]: (state, { type }) => type,
    [ActionTypes.FETCH_FEATURED_ARTICLES_ERROR]: (state, { type }) => type,
    [ActionTypes.FETCH_FEATURED_ARTICLES_NOT_FOUND]: (state, { type }) => type
  }
);

export default combineReducers({
  list,
  status
});
